(function ($) {
    var triggerExpand = function (e) {
        e.preventDefault();

        var $el = $(this),
            $parent = $el.parent('.accordion-item');

        $parent.toggleClass('active');
    };

    var init = function () {
        $('body').on('click', '.accordion-link', triggerExpand);
    };

    $(function () {
        init();
    });
})(jQuery);